import { useState } from "react";
import { LoadingSkeleton } from "@narmi/design_system";
import { formatBulkTemplate } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates";
import type { FormattedBulkTemplate } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates/types";
import { useAllAccounts } from "byzantine/src/dbbl/businessLogic/entities";
import ViewPaymentsDialog from "./ViewPaymentsDialog";
import VersionCard from "./VersionCard";

type VersionHistoryTabProps = {
  templateUuid: API.BulkTemplateId;
  groupState: string;
  activeVersionId: API.BulkTemplateVersionId | null;
  versions: API.BulkTemplateVersion[];
  versionsLoading: boolean;
  onCopyToNewVersion?: (versionId: API.BulkTemplateVersionId) => void;
};

const VersionHistoryTab = ({
  templateUuid,
  groupState,
  activeVersionId,
  versions,
  versionsLoading,
  onCopyToNewVersion,
}: VersionHistoryTabProps) => {
  const accounts = useAllAccounts();

  const [selectedVersion, setSelectedVersion] =
    useState<API.BulkTemplateVersion | null>(null);

  const handleViewPayments = (version: API.BulkTemplateVersion) => {
    setSelectedVersion(version);
  };

  const formattedVersion: FormattedBulkTemplate | null = selectedVersion
    ? formatBulkTemplate(
        {
          id: templateUuid,
          name: selectedVersion.name,
          state: groupState,
          last_used: selectedVersion.last_used,
          created_at: selectedVersion.created_at,
          updated_at: selectedVersion.updated_at,
          archived_at: null,
          active_version: selectedVersion,
          pending_version: null,
        },
        accounts
      )
    : null;

  return (
    <div className="margin--top--l">
      <LoadingSkeleton
        content="paragraph"
        isLoading={versionsLoading && versions.length === 0}
      >
        {versions.map((version) => (
          <div key={version.id} className="margin--bottom--l">
            <VersionCard
              version={version}
              groupState={groupState}
              activeVersionId={activeVersionId}
              onViewPayments={handleViewPayments}
              {...(onCopyToNewVersion && {
                onCopyToNewVersion,
              })}
            />
          </div>
        ))}
      </LoadingSkeleton>
      {formattedVersion && (
        <ViewPaymentsDialog
          isOpen={Boolean(selectedVersion)}
          handleClose={() => setSelectedVersion(null)}
          template={formattedVersion}
          variant="version"
        />
      )}
    </div>
  );
};

export default VersionHistoryTab;
